import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'deposit-coinpayments.component',
  templateUrl: '../sharedTemplates/deposit-coinpayments.component.html',
})
export class DepositCoinPaymentsComponent implements OnInit {
  coinbaseDatas: UntypedFormGroup;
  coinbaseDataRaw: any;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper
  ) {
    this.coinbaseDatas = _FormBuilder.group({
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(10)]),
      coinList: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    });
  }

  ngOnInit() {
    this.coinbaseDatas.valueChanges.subscribe(x => {
      this.coinbaseDataRaw = x;
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Bitcoin', true);
  }

  submitCoinbaseData() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.depositCoinPayments(this.coinbaseDataRaw.amount, this.coinbaseDataRaw.coinList).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      //////console.log("COIN_BASE_", result);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'errorcode') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          window.location = result.message;
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
